import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  MapPin,
  Clock,
  Tag,
  ChevronLeft,
  ChevronRight,
  Award,
  Search,
  Store,
  X,
  Star,
  Briefcase,
  Building
} from "lucide-react";
import "./MerchantListing/listing.css";

import { useDispatch, useSelector } from "react-redux";
import {
  fetchBusinessTypes,
  fetchBusinessCategories,
  fetchBusinessServices,
} from "../features/master/masterThunks";

import {
  searchMerchantsThunk,
} from "../features/home/merchantSearchSlice";

const MerchantSearchCards = () => {
  const dispatch = useDispatch();
  const [cardsPerPage, setCardsPerPage] = useState(50);
  const { businessTypes, businessCategories, businessServices } = useSelector((state) => state.master);
  const { results, loading } = useSelector((state) => state.merchantSearch);

  const [activeBusinessType, setActiveBusinessType] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeService, setActiveService] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(1);

  const merchants = results?.data?.merchants || [];
  const totalPages = results?.totalPages || 1;

  useEffect(() => {
    dispatch(fetchBusinessTypes());
  dispatch(searchMerchantsThunk({ page: 1, limit: cardsPerPage }));
  }, [dispatch]);

  const handleSearchText = (e) => {
    const value = e.target.value;
    setSearchText(value);
    setPage(1);
    dispatch(searchMerchantsThunk({ query: value, page: 1, limit: 50 }));
  };

  const handleBusinessTypeClick = (type) => {
    setActiveBusinessType(type._id);
    setActiveCategory(null);
    setActiveService(null);

    // filter merchants
    dispatch(
      searchMerchantsThunk({
        businessTypeId: type._id,
        page: 1,
        limit: 50,
      })
    );

    // fetch categories + services
    dispatch(fetchBusinessCategories(type._id));
    dispatch(fetchBusinessServices(type._id));
  };

  // CATEGORY Click
 const handleCategoryClick = (cat) => {
  setActiveCategory(cat._id);
  setActiveService(null); // ✅ RESET service

  dispatch(
    searchMerchantsThunk({
      businessTypeId: activeBusinessType,
      businessCategoryId: cat._id,
      page: 1,
      limit: 50,
    })
  );
};


  const resetFilters = () => {
    setActiveBusinessType(null);
    setActiveCategory(null);
    setActiveService(null);
    setPage(1);
    dispatch(searchMerchantsThunk({ page: 1, limit: 50 }));
  };

const handlePageChange = (newPage) => {
  setPage(newPage);

  const params = {
    page: newPage,
    limit: 50,
  };

  if (searchText) params.query = searchText;
  if (activeBusinessType) params.businessTypeId = activeBusinessType;
  if (activeCategory) params.businessCategoryId = activeCategory;
  if (activeService) params.businessServiceId = activeService; // ✅ CRITICAL

  dispatch(searchMerchantsThunk(params));
  window.scrollTo({ top: 0, behavior: "smooth" });
};



  return (
    <div className="merchant-main-wrapper">
      <div className="container-search">
        {/* HEADER SECTION */}
        <div className="search-header">
          <h1 className="main-title">Discover Top Merchants</h1>
          <p className="subtitle">Find the perfect service provider for your needs</p>
        </div>
      
      {/* ================= SEARCH BAR ================= */}
<div className="search-header mt-3">
  <div className="search-bar-wrapper">
  <Search className="text-primary" size={20} />
    <input
      type="text"
      className="modern-search-input"
      placeholder="Search by name, district, or area..."
      value={searchText}
      onChange={handleSearchText}
    />
    {searchText && (
      <X
        className="clear-search"
        size={18}
        onClick={() => {
          setSearchText("");
          resetFilters();
        }}
      />
    )}
  </div>
</div>
        {/* CHIP FILTERS */}
        <div className="filter-section">
          <div className="filter-scroll-wrapper">
            <div className="scroll-container">
            {activeBusinessType && (
              <button className="category-chip reset-chip" onClick={resetFilters}>
                <X size={16} /> <span>Clear All</span>
              </button>
            )}
            
            {!activeBusinessType && (
                    <div className="category-scroll-wrapper">
                      {businessTypes?.map((type) => (
                        <button
                          key={type._id}
                          className={`category-chip`}
                          onClick={() => handleBusinessTypeClick(type)}>
                          <Store size={20} />
                          <span>{type.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                    {/* 🔥 SHOW CATEGORIES + SERVICES WHEN BUSINESS TYPE IS SELECTED */}
                        {activeBusinessType && (
                          <>
                            {/* Business Categories */}
                            {businessCategories?.length > 0 && (
                              <div className="category-scroll-wrapper">
                                {businessCategories.map((category) => (
                                  <button
                                    key={category._id}
                                    className={`category-chip ${
                                      activeCategory === category._id ? "active-chip" : ""
                                    }`}
                                    onClick={() => handleCategoryClick(category)}
                                  >
                                    <Store size={20} />
                                    <span>{category.name}</span>
                                  </button>
                                ))}
                              </div>
                            )}
                  
                            {/* Business Services */}
                          {businessServices?.length > 0 && (
                    <div className="category-scroll-wrapper mt-2">  
                      {businessServices.map((service) => (
                        <button
                          key={service._id}
                          className="category-chip"
                          onClick={() => {
  setActiveService(service._id);
  setPage(1);

  dispatch(
    searchMerchantsThunk({
      businessTypeId: activeBusinessType,
      businessCategoryId: service._id,
      page: 1,
      limit: 50,
    })
  );
}}
                        >
                          <Store size={20} />
                          <span>{service.name}</span>
                        </button>
                      ))}
                    </div>
                  )}
                  
                          </>
                        )}
            </div>
          </div>
        </div>

        {/* GRID RESULTS */}
        {loading ? (
          <div className="loader-container">
            <div className="spinner"></div>
            <p className="loading-text">Loading merchants...</p>
          </div>
        ) : (
          <div className="merchants-grid">
            {merchants.map((merchant) => (
              <Link key={merchant.merchantId} to={`/merchant-detail/${merchant.merchantId}`} className="merchant-card">
                <div className="image-wrapper">
                  <div className="image-overlay"></div>
                  {merchant.businessLogo ? (
               <img
              src={`${process.env.REACT_APP_IMAGE_BASE_URL}${merchant.businessLogo}`}
             alt={merchant.businessName}
             className="business-image"
             loading="lazy"
             decoding="async"
             />
            ) : (
          <div className="no-logo-placeholder">
        <Building size={48} color="#6154A4" />
           </div>
         )}
                {merchant.overview?.rating && merchant.overview.rating !== "N/A" && (
  <div className="rating-badge">
    <Star size={12} fill="currentColor" />
    <span>{merchant.overview.rating}</span>
  </div>
)}

                </div>

                <div className="card-body">
                  <span className="type-tag">{merchant.businessType}</span>
                  <h3 className="business-name">{merchant.businessName}</h3>
                  
                  <div className="meta-info">
                    <div className="info-item">
                      <MapPin size={14} /> <span>{merchant.state},{merchant.district}</span>
                    </div>
                    <div className="info-item">
                      <Award size={14} /> <span>{merchant.quickInfo?.speciality || "N/A"}</span>
                    </div>
                    <div className="info-item">
                      <Briefcase size={14} /> <span>{merchant.overview?.experienceInYears || "N/A"} Years</span>
                    </div>
                  </div>                  
                  <button className="view-details-btn">
                    View Details
                    <ChevronRight size={16} className="btn-arrow" />
                  </button>
                </div>
              </Link>
            ))}
          </div>
        )}

        {/* EMPTY STATE */}
        {!loading && merchants.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">
              <Store size={64} />
            </div>
            <h3>No Merchants Found</h3>
            <p>Try adjusting your filters or search criteria</p>
          </div>
        )}

        {/* MODERN PAGINATION */}
        {totalPages > 1 && (
          <div className="pagination">
            <button className="pag-nav" onClick={() => handlePageChange(page - 1)} disabled={page === 1}>
              <ChevronLeft size={20} />
            </button>
            <span className="page-indicator">
              <span className="current-page">{page}</span>
              <span className="page-divider">/</span>
              <span className="total-pages">{totalPages}</span>
            </span>
            <button className="pag-nav" onClick={() => handlePageChange(page + 1)} disabled={page === totalPages}>
              <ChevronRight size={20} />
            </button>
          </div>
        )}
      </div>
      
      <style jsx>{`
        :root {
          --gradient-primary: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          --gradient-secondary: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
          --gradient-accent: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
          --color-primary: #667eea;
          --color-primary-dark: #5568d3;
          --color-primary-light: #8796ef;
          --color-secondary: #764ba2;
          --color-accent: #f5576c;
          --color-success: #10b981;
          --bg-primary: #ffffff;
          --bg-secondary: #f8fafc;
          --bg-tertiary: #f1f5f9;
          --text-primary: #1e293b;
          --text-secondary: #475569;
          --text-muted: #94a3b8;
          --border-color: #e2e8f0;
          --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
          --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
          --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
          --shadow-xl: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
          --radius-sm: 8px;
          --radius-md: 12px;
          --radius-lg: 16px;
          --radius-xl: 24px;
          --transition-base: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }

        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        .merchant-main-wrapper {
          background: linear-gradient(to bottom, #f8fafc 0%, #ffffff 100%);
          min-height: 100vh;
          padding: 3rem 1rem;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', sans-serif;
          position: relative;
        }

        .merchant-main-wrapper::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 400px;
          background: var(--gradient-primary);
          opacity: 0.05;
          z-index: 0;
        }

        .container-search {
          max-width: 1400px;
          margin: 0 auto;
          position: relative;
          z-index: 1;
        }

        /* Header & Search */
        .search-header {
          text-align: center;
          animation: fadeInDown 0.6s ease-out;
        }

        @keyframes fadeInDown {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .main-title {
          font-size: 3rem;
          font-weight: 800;
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: -0.03em;
          margin-bottom: 0.75rem;
          line-height: 1.2;
        }

        .subtitle {
          font-size: 1.125rem;
          color: var(--text-secondary);
          font-weight: 400;
        }

        /* Horizontal Scroll Filters */
        .filter-section {
          margin-bottom: 2.5rem;
          animation: fadeIn 0.6s ease-out 0.2s both;
        }

        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }

        .filter-scroll-wrapper {
          position: relative;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .scroll-container {
          display: flex;
          flex-wrap: wrap;
          gap: 0.75rem;
          padding: 12px 8px;
          flex: 1 1 auto;
          min-width: 0;
          width: 100%;
        }

        /* The chip groups are flex children of .scroll-container; they need
           to wrap onto multiple rows themselves instead of scrolling, and
           take the full row width so wrapping happens within the container
           instead of chips overflowing off the edge. */
        .scroll-container .category-scroll-wrapper {
          overflow: visible;
          flex-wrap: wrap;
          min-width: 0;
          width: 100%;
          flex-shrink: 1;
          padding: 0;
        }

        .category-chip {
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 10px 20px;
          background: var(--bg-primary);
          border: 2px solid var(--border-color);
          border-radius: 50px;
          white-space: nowrap;
          cursor: pointer;
          transition: var(--transition-base);
          color: var(--text-primary);
          font-weight: 600;
          font-size: 0.9rem;
          box-shadow: var(--shadow-sm);
        }

        .category-chip:hover {
          border-color: var(--color-primary);
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
          transform: translateY(-2px);
          box-shadow: var(--shadow-md);
        }

        .category-chip.active {
          background: var(--gradient-primary);
          color: white;
          border-color: transparent;
          box-shadow: var(--shadow-lg);
        }

        .chip-icon {
          transition: transform 0.3s ease;
        }

        .category-chip:hover .chip-icon {
          transform: scale(1.1);
        }

        .reset-chip {
          background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
          color: #dc2626;
          border-color: #fca5a5;
          font-weight: 700;
        }

        .reset-chip:hover {
          background: linear-gradient(135deg, #fecaca 0%, #fca5a5 100%);
          transform: translateY(-2px);
        }

        /* Loading State */
        .loader-container {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 4rem 2rem;
          gap: 1.5rem;
        }

        .spinner {
          width: 60px;
          height: 60px;
          border: 4px solid var(--bg-tertiary);
          border-top-color: var(--color-primary);
          border-radius: 50%;
          animation: spin 0.8s linear infinite;
        }

        @keyframes spin {
          to { transform: rotate(360deg); }
        }

        .loading-text {
          color: var(--text-secondary);
          font-size: 1.1rem;
          font-weight: 500;
        }

        /* Grid Layout */
        .merchants-grid {
          display: grid;
          gap: 1.5rem;
          grid-template-columns: repeat(5, 1fr);
          animation: fadeInUp 0.6s ease-out 0.3s both;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        /* Merchant Card */
        .merchant-card {
          background: var(--bg-primary);
          border-radius: var(--radius-lg);
          overflow: hidden;
          text-decoration: none;
          transition: var(--transition-base);
          border: 1px solid var(--border-color);
          display: flex;
          flex-direction: column;
          box-shadow: var(--shadow-sm);
          position: relative;
        }

        .merchant-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: var(--gradient-primary);
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 0;
          pointer-events: none;
        }

        .merchant-card:hover {
          transform: translateY(-12px) scale(1.02);
          box-shadow: var(--shadow-xl);
          border-color: var(--color-primary-light);
        }

        .merchant-card:hover::before {
          opacity: 0.03;
        }

        .image-wrapper {
          position: relative;
          height: 170px;
          background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
          overflow: hidden;
        }

        .image-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(180deg, rgba(0,0,0,0) 0%, rgba(0,0,0,0.1) 100%);
          opacity: 0;
          transition: opacity 0.3s ease;
          z-index: 1;
        }

        .merchant-card:hover .image-overlay {
          opacity: 1;
        }

        .image-wrapper img {
          width: 100%;
          height: 100%;
          object-fit: contain;
          padding: 1rem;
          transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
        }

        .merchant-card:hover .image-wrapper img {
          transform: scale(1.1);
        }

        .rating-badge {
          position: absolute;
          top: 16px;
          right: 16px;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.95) 0%, rgba(118, 75, 162, 0.95) 100%);
          backdrop-filter: blur(10px);
          padding: 6px 12px;
          border-radius: 50px;
          display: flex;
          align-items: center;
          gap: 6px;
          font-weight: 700;
          font-size: 0.85rem;
          color: #ffffff;
          box-shadow: var(--shadow-lg);
          z-index: 2;
          transition: var(--transition-base);
        }

        .merchant-card:hover .rating-badge {
          transform: scale(1.1);
        }

        .card-body {
          padding: 1.25rem;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          position: relative;
          z-index: 1;
        }

        .type-tag {
          font-size: 0.7rem;
          text-transform: uppercase;
          font-weight: 800;
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          letter-spacing: 0.08em;
          // margin-bottom: 0.75rem;
        }

        .business-name {
          font-size: 1.15rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.8rem;
          line-height: 1.3;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .meta-info {
          margin-top: auto;
          margin-bottom: 1rem;
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .info-item {
          display: flex;
          align-items: center;
          gap: 8px;
          font-size: 0.8rem;
          color: var(--text-secondary);
          font-weight: 500;
        }

        .info-item svg {
          color: var(--color-primary);
          flex-shrink: 0;
        }

        .view-details-btn {
          width: 100%;
          padding: 8px 16px;
          background: var(--gradient-primary);
          color: white;
          border: none;
          border-radius: var(--radius-md);
          font-weight: 600;
          font-size: 0.75rem;
          cursor: pointer;
          transition: var(--transition-base);
          box-shadow: var(--shadow-md);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 8px;
        }

        .view-details-btn:hover {
          transform: translateY(-2px);
          box-shadow: var(--shadow-lg);
        }

        .view-details-btn:active {
          transform: translateY(0);
        }

        .btn-arrow {
          transition: transform 0.3s ease;
        }

        .view-details-btn:hover .btn-arrow {
          transform: translateX(4px);
        }

        /* Empty State */
        .empty-state {
          text-align: center;
          padding: 5rem 2rem;
          animation: fadeIn 0.6s ease-out;
        }

        .empty-icon {
          width: 120px;
          height: 120px;
          margin: 0 auto 2rem;
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          color: var(--color-primary);
        }

        .empty-state h3 {
          font-size: 1.75rem;
          font-weight: 700;
          color: var(--text-primary);
          margin-bottom: 0.75rem;
        }

        .empty-state p {
          font-size: 1.1rem;
          color: var(--text-secondary);
        }

        /* Pagination */
        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 2rem;
          margin-top: 4rem;
          animation: fadeIn 0.6s ease-out 0.4s both;
        }

        .pag-nav {
          width: 48px;
          height: 48px;
          padding: 0;
          border-radius: 50%;
          border: 2px solid var(--border-color);
          background: var(--bg-primary);
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: var(--transition-base);
          box-shadow: var(--shadow-sm);
          color: var(--text-primary);
        }

        .pag-nav:disabled {
          opacity: 0.3;
          cursor: not-allowed;
          transform: none;
        }

        .pag-nav:not(:disabled):hover {
          border-color: var(--color-primary);
          background: var(--gradient-primary);
          color: white;
          transform: scale(1.1);
          box-shadow: var(--shadow-md);
        }

        .pag-nav:not(:disabled):active {
          transform: scale(0.95);
        }

        .page-indicator {
          font-size: 1.1rem;
          font-weight: 600;
          color: var(--text-primary);
          display: flex;
          align-items: center;
          gap: 8px;
          padding: 12px 24px;
          background: var(--bg-primary);
          border-radius: 50px;
          box-shadow: var(--shadow-sm);
          border: 2px solid var(--border-color);
        }

        .current-page {
          font-size: 1.3rem;
          font-weight: 800;
          background: var(--gradient-primary);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
        }

        .page-divider {
          color: var(--text-muted);
        }

        .total-pages {
          color: var(--text-secondary);
        }

        /* Responsive Adjustments */
        @media (max-width: 1400px) {
          .merchants-grid {
            grid-template-columns: repeat(4, 1fr);
            gap: 1.5rem;
          }
        }

        @media (max-width: 1200px) {
          .merchants-grid {
            grid-template-columns: repeat(3, 1fr);
            gap: 1.5rem;
          }
        }

        @media (max-width: 768px) {
          .merchant-main-wrapper {
            padding: 2rem 1rem;
          }

          .main-title {
            font-size: 2.25rem;
          }

          .subtitle {
            font-size: 1rem;
          }

          .merchants-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 1rem;
          }

          .filter-section {
            margin-bottom: 2rem;
          }

          .pagination {
            margin-top: 3rem;
            gap: 1.5rem;
          }

          .image-wrapper {
            height: 160px;
          }

          .card-body {
            padding: 1rem;
          }

          .business-name {
            font-size: 1rem;
          }

          .info-item {
            font-size: 0.75rem;
            gap: 6px;
          }

          .info-item svg {
            width: 12px;
            height: 12px;
          }

          .view-details-btn {
            padding: 8px 16px;
            font-size: 0.8rem;
          }
        }

        @media (max-width: 640px) {
          .merchant-main-wrapper {
            padding: 1.5rem 0.75rem;
          }

          .main-title {
            font-size: 1.875rem;
          }

          .subtitle {
            font-size: 0.95rem;
          }

          .merchants-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.875rem;
          }

          .image-wrapper {
            height: 140px;
          }

          .business-name {
            font-size: 0.95rem;
            margin-bottom: 0.75rem;
          }

          .type-tag {
            font-size: 0.65rem;
            margin-bottom: 0.5rem;
          }

          .category-chip {
            padding: 8px 16px;
            font-size: 0.85rem;
          }

          .pagination {
            gap: 1rem;
          }

          .pag-nav {
            width: 44px;
            height: 44px;
          }

          .page-indicator {
            padding: 10px 20px;
            font-size: 1rem;
          }

          .current-page {
            font-size: 1.2rem;
          }

          .rating-badge {
            padding: 4px 8px;
            font-size: 0.75rem;
          }

          .rating-badge svg {
            width: 10px;
            height: 10px;
          }
        }

        @media (max-width: 480px) {
          .main-title {
            font-size: 1.625rem;
          }

          .search-header {
            margin-bottom: 2rem;
          }

          .filter-section {
            margin-bottom: 1.5rem;
          }

          .scroll-container {
            gap: 0.5rem;
          }

          .category-chip {
            padding: 7px 14px;
            font-size: 0.8rem;
          }

          .merchants-grid {
            gap: 0.75rem;
          }

          .image-wrapper {
            height: 130px;
          }

          .card-body {
            padding: 0.875rem;
          }

          .business-name {
            font-size: 0.9rem;
          }

          .meta-info {
            margin-bottom: 0.75rem;
            gap: 0.375rem;
          }

          .info-item {
            font-size: 0.7rem;
          }

          .view-details-btn {
            padding: 7px 14px;
            font-size: 0.75rem;
          }

          .btn-arrow {
            width: 14px;
            height: 14px;
          }
        }

        @media (max-width: 380px) {
          .merchants-grid {
            grid-template-columns: repeat(2, 1fr);
            gap: 0.625rem;
          }

          .image-wrapper {
            height: 120px;
          }

          .business-name {
            font-size: 0.85rem;
          }

          .info-item {
            font-size: 0.65rem;
          }
        }
          
        .search-bar-wrapper {
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 4px 14px rgba(0,0,0,0.08);
  max-width: 600px;
  margin: auto;
}

.modern-search-input {
  border: none;
  outline: none;
  flex: 1;
  font-size: 15px;
  margin-left: 10px;
}

.search-icon {
  color: #777;
}

.clear-search {
  cursor: pointer;
  color: #999;
}

      `}</style>
    </div>
  );
};

export default MerchantSearchCards;